// extracted by mini-css-extract-plugin
export default {"footer":"PageLayout-module--footer--MDE3C","header":"PageLayout-module--header--HNHkr"};